module.exports = __webpack_public_path__ + "img/HPS019NG.2ba2206f.png";